<template>
  <section class="product-info">
    <h2 class="product-name" v-text="title"></h2>
    <p>
      <span class="product-sales"
        ><span class="num" v-text="sales"></span> 人已购买</span
      >超高性价比
    </p>
  </section>
</template>

<script>
  export default {
    name: 'DetailInfo',
    props: ['title', 'sales'],
  };
</script>

<style lang="scss" scoped>
/* 商品信息 */
.product-info {
  padding: 10px 20px;
  font-size: 12px;
  color: #999;
  background-color: #fff;
}

.product-name {
  margin-bottom: 10px;
  font-size: 16px;
  color: #000;
  font-weight: bold;
}

.product-name::before {
  content: "推荐";
  position: relative;
  top: -2px;
  margin-right: 6px;
  padding: 2px 4px;
  font-size: 12px;
  color: #fff;
  background-color: #30c27b;
  border-radius: 2px;
}

.product-sales {
  margin-right: 20px;
}

.product-sales .num {
  color: #e44837;
}
</style>
